const HeroBannerV2 = (() => {
    const DOM = {};

    const cacheDOM = () => {
        DOM.wrappers = document.querySelectorAll('.js-hero-v2-video');
    };

    const removePoster = (wrapper) => {
        const poster = wrapper.querySelector('.hero-banner-v2__poster');
        const play = wrapper.querySelector('.hero-banner-v2__play');

        if (poster) {
            poster.remove();
        }
        if (play) {
            play.remove();
        }
    };

    const createIframe = (wrapper) => {
        const type = wrapper.dataset.type;
        const id = wrapper.dataset.id;

        if (!id) {
            return;
        }

        const iframe = document.createElement('iframe');
        let src;

        if (type === 'vimeo') {
            src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&loop=1&autopause=0&background=1&muted=1';
        } else if (type === 'youtube') {
            src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&mute=1&controls=0&loop=1&playlist=' + id + '&disablekb=1&rel=0&modestbranding=1&playsinline=1';
        }

        if (!src) {
            return;
        }

        iframe.setAttribute('src', src);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');

        wrapper.appendChild(iframe);

        iframe.addEventListener('load', () => {
            removePoster(wrapper);
        });
    };

    const initSelfHosted = (wrapper) => {
        const video = wrapper.querySelector('video');

        if (!video) {
            return;
        }

        video.addEventListener('playing', () => {
            removePoster(wrapper);
        });
    };

    const initVideo = (wrapper) => {
        const type = wrapper.dataset.type;

        if (type === 'self-hosted') {
            initSelfHosted(wrapper);
            return;
        }

        createIframe(wrapper);
    };

    const init = () => {
        cacheDOM();

        if (!DOM.wrappers.length) {
            return;
        }

        DOM.wrappers.forEach((wrapper) => {
            initVideo(wrapper);
        });
    };

    return {
        init,
    };
})();

export default HeroBannerV2;
